




































































































import { MenuItems } from '@/types/utilTypes'
import Vue, { PropType } from 'vue'

export default Vue.extend({
    name: 'LoadItemMenu',
    props: {
        items: {
            type: Object as () => MenuItems<any>,
            required: true
        },
        labelField: {
            type: String,
            default: 'name'
        },
        subtitleField: {
            type: String,
            default: 'user'
        },
        emptyOwnedText: {
            type: String,
            default: 'No saved reports'
        },
        emptyPublicText: {
            type: String,
            default: 'No public reports'
        },
        canDeleteItem: {
            // 1. Fixed type casting using "unknown"
            type: Function as unknown as PropType<(item: any) => boolean>,
      
            // 2. Fixed factory function wrapper
            default: () => () => true
        }
    },
    data() {
        return {
            menuOpen: false
        }
    },
    methods: {
        onLoadItem(item: any) {
            this.menuOpen = false
            this.$emit('load-item', item)
        },
        onChooseDeleteItem(item: any) {
            this.menuOpen = false
            this.$emit('delete-item', item)
        }
    }
})
